import React from "react";
import { format, parseISO } from "date-fns";
import { useTenant, useVenue } from "../api/helpers";

const Header = () => {
  const venue = useVenue();
  const tenant = useTenant();

  if (!tenant || !venue) {
    return null;
  }

  return (
    <header>
      <div className="headerContainer">
        <div className="logo">
          <img src={tenant.icon} alt="logo" />
        </div>
        <div className="title">
          <h3 className="headerTitle">{venue.name}</h3>
          <h5 className="headerDate">
            {format(parseISO(venue.eventStartTime), "EEEE, MMMM do, y")}
            {" to "}
            {format(parseISO(venue.eventEndTime), "EEEE, MMMM do, y")}
          </h5>
        </div>
      </div>
      <style jsx>{`
        .logo {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        ::-webkit-scrollbar {
          width: 4px;
          height: 0;
        }
        ::-webkit-scrollbar-track {
          background: #e3e5e8;
        }
        ::-webkit-scrollbar-thumb {
          background: ${tenant.color};
        }
        header {
          display: flex;
          padding: 10px 20px;
          flex: 0 1 auto;
          background: #f8f9fa;
          box-shadow: 0 0 16px rgba(166, 171, 189, 0.6);
          z-index: 3;
        }
        .headerContainer {
          display: flex;
        }
        .headerTitle {
          margin: 0 0 0 20px;
          font-weight: bold;
          font-size: 2rem;
          color: #343434;
        }
        .headerDate {
          margin: 7px 0 0 20px;
          font-weight: normal;
          font-size: 0.9rem;
          color: #343434;
        }
        .title {
          margin: 10px 0 0 0;
        }
        img {
          max-height: 55px;
          max-width: 55px;
          width: 100%;
          /*height: 100%;*/
          border: none;
        }
      `}</style>
    </header>
  );
};

export default Header;
